import React, { useEffect, useState } from 'react';
import { getCarrierScacs } from 'utils/OrderWebAPIUtils';
import {
  Button,
  Label,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@cargomatic/ui';
import { Trash } from 'lucide-react';
import { uniqBy } from 'lodash';
import FormGrid from './FormGrid';

export default function SteamshipRailroadRateConditionField({
  condition,
  onChange,
  onRemove,
}) {
  const [items, setItems] = useState([]);
  const { criteria: value } = condition;

  function handleRemove() {
    onRemove(condition);
  }

  function handleChange(criteria) {
    onChange({ ...condition, criteria });
  }

  async function fetchData() {
    let {
      entity: { OCEAN_SCAC_CODES: oceanScacs },
    } = await getCarrierScacs();

    setItems(uniqBy(oceanScacs, (item) => item.ocean_scac));
  }

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <FormGrid>
      <Label className="w-48">Steamship/Railroad</Label>
      <Select className="flex-1" value={value} onValueChange={handleChange}>
        <SelectTrigger className="" valu>
          <SelectValue placeholder="Steamship/Railroad" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>Steamship/Railroad</SelectLabel>
            {items.map((item) => (
              <SelectItem value={item.ocean_scac} key={item.ocean_scac}>
                {item.carrier}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <div>
        <Button variant="icon" onClick={handleRemove}>
          <Trash className="w-3.5 h-3.5" />
        </Button>
      </div>
    </FormGrid>
  );
}
